<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="80"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <!-- <el-form-item
        class="el_from"
        label="活动名称:"
        slot="approvedType"
        style="margin:0"
      >
        <el-select v-model="activityName" placeholder="请选择活动名称查询" filterable clearable>
          <el-option
            v-for="item in activitySelectList"
            :key="item.id"
            :label="item.userName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <div slot="AddSlot">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="drawerDialog = true"
          >创建活动</el-button
        >
      </div>
    </GlobalForm>
    <!-- 抽屉 -->
    <el-drawer
      title="创建活动"
      :before-close="cancelForm"
      :visible.sync="drawerDialog"
      direction="rtl"
      custom-class="demo-drawer"
      :wrapper-closable="false"
      size="600px"
      ref="drawer"
    >
      <el-form
        :model="drawerInitData"
        ref="drawerForm"
        label-width="145px"
        label-position="left"
        :rules="drawerFormRules"
        class="el_from"
      >
        <el-form-item label="活动名称" prop="activityName">
          <el-input
            placeholder="输入活动名称,限50字"
            type="text"
            maxlength="50"
            show-word-limit
            class="drawerWith"
            v-model.trim="drawerInitData.activityName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="活动海报" prop="activityPoster" :required="true">
          <el-row style="display: flex; align-items: center">
            <el-col :span="7">
              <ElImgUpload
                :exist-image="drawerInitData.activityPoster"
                place-txt="建议图片尺寸为700px * 100px"
                @handleDelete="
                  handleUploadDelete(drawerInitData.activityPoster)
                "
                @handleChange="handleUploadChange($event)"
              />
            </el-col>
            <el-col :span="1">
              <el-button size="mini" type="warning" @click="referPic"
                >参考海报</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="活动开始时间"
          prop="activityStart"
          :required="true"
        >
          <div class="drawerWith">
            <el-date-picker
              v-model="drawerInitData.activityStart"
              type="date"
              :picker-options="pickerOptions0"
              value-format="yyyy-MM-dd"
              placeholder="选择活动开始时间"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="活动结束时间" prop="activityEnd" :required="true">
          <el-radio-group
            class="timeStyle"
            v-model="drawerInitData.activityEnd"
          >
            <el-row>
              <el-radio label="00">不定时：所有活动商品售完自动结束</el-radio>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-radio label="01"
                ><span style="margin-right: 10px">定时结束</span>
                <div style="width: 500px; margin-top: 10px">
                  <el-date-picker
                    v-model="timing"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束时间"
                    :picker-options="pickerOptions1"
                    :disabled="drawerInitData.activityEnd == '00'"
                  >
                  </el-date-picker>
                </div>
              </el-radio>
            </el-row>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要保存顾客信息(姓名、手机号)" required>
          <el-radio-group v-model="drawerInitData.isSave">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin-top: -15px;">
          <p style="font-size: 15px">换新补贴设置</p>
          <div class="huanxin">
            <el-form-item label="换新补贴方式" label-width="110px" required>
              <el-radio-group v-model="drawerInitData.subsidyWay">
                <el-radio label="00"> 旧机加价补贴 </el-radio>
                <el-radio label="01">换新抵扣券补贴</el-radio>
              </el-radio-group>
              <p class="wen_text">
                <span style="margin-right: 20px">顾客先收款旧机+新机补贴,再付款购买新机</span
                ><span>旧机与新机财务单独核算</span>
              </p>
            </el-form-item>
            <el-form-item label="启用赠送礼品" label-width="110px" required>
              <el-switch v-model="drawerInitData.isOpenGift"> </el-switch>
            </el-form-item>
            <p style="font-size: 12px; color: #666666; margin-left: 110px">
              {{ drawerInitData.isOpenGift?"提交后在活动列表设置赠品":"该活动暂不需要设置赠品" }}
            </p>
          </div>
        </div>
        <el-row style="margin-top: 60px">
          <el-col :span="7" :offset="17">
            <el-button size="small" @click="cancelForm">取消</el-button>
            <el-button size="small" type="primary" @click="handleClose"
              >确认</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择海报 -->
    <el-dialog
      title="选择海报"
      :visible.sync="posterDialogVisible"
      :close-on-click-modal="false"
      width="880px"
    >
      <ul
        style="
          padding: 20px;
          width: 840px;
          height: 300px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <li
          v-for="(item, index) in posterList"
          :key="index"
          style="width: 370px"
        >
          <div
            style="display: flex; justify-content: center; align-items: center"
            @click="choosePoster(index)"
          >
            <img
              v-if="isCheckPoster === index"
              style="width: 18px; cursor: pointer"
              src="https://img.fanxinghuishou.cn/20231216/481566005.png"
              alt=""
            />
            <img
              v-else
              style="width: 18px; cursor: pointer"
              src="https://img.fanxinghuishou.cn/20231216/607204106.png"
              alt=""
            />
            <div>
              <img
                style="
                  width: 370px;
                  height: 54px;
                  border-radius: 10px;
                  margin-left: 10px;
                  cursor: pointer;
                "
                :src="item.posterImg"
                alt=""
                @click="seeSampleImage(item.img)"
              />
            </div>
          </div>
          <span
            class="text-down"
            style="display: flex; justify-content: end; margin-top: 5px"
            @click="downPoster(item)"
            >下载文件</span
          >
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="posterDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitAdd">确定选择</el-button>
      </span>
    </el-dialog>
    <!-- <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
        posterDialogVisible = true
      }
    " :url-list="imgList" /> -->
    <!-- 创建成功 -->
    <el-dialog
      title="创建成功"
      :visible.sync="createShow"
      :close-on-click-modal="false"
      width="300px"
      @closed="automaticClosed"
    >
      <div class="enable-tip">
        <div>活动已创建成功，请在活动开始前，添加活动商品及参与门店</div>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click.native="creatSubmit"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import ElImgUpload from "../../../components/global/components/elements/upload-element";
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Form",
  components: {
    ElImgUpload,
  },
  data() {
    return {
      isCheckPoster: "",
      showViewer: false,
      posterDialogVisible: false,
      posterList: [],
      // 抽屉
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return (
            time.getTime() <
              new Date(this.drawerInitData.activityStart) - 8.64e7 ||
            time.getTime() < Date.now()
          );
        },
      },
      drawerDialog: false,
      timing: null,
      drawerInitData: {
        activityName: "",
        activityPoster: "",
        activityStart: "",
        activityEnd: "00",
        isOpenGift:false,
        subsidyWay:"00",
        isSave: true,
        isTiming: false,
      },
      drawerFormRules: {
        activityName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入活动名称",
            max: 50,
          },
        ],
        activityStart: [
          {
            required: true,
            trigger: "blur",
            message: "请选择活动开始时间",
          },
        ],
        isSave: [
          {
            required: true,
            trigger: "blur",
            message: "是否需要保存顾客信息(姓名、手机号)",
          },
        ],
        activityPoster: [
          {
            required: true,
            trigger: "blur",
            message: "请上传活动海报",
          },
        ],
        activityEnd: [
          {
            required: true,
            trigger: "blur",
            message: "请选择活动结束时间",
          },
        ],
      },
      posterData: [],
      posterformRules: {},
      posterDialogShow: false,
      createShow: false,
      dialogVisible: false,
      btnLoading: false,
      // end
      // activityName:"",
      activitySelectList: [],
      initData: { entryTime: [moment().day(moment().day()).format("YYYY-MM-DD 00:00:00"),
                        moment().format("YYYY-MM-DD 23:59:59")]},
      formItemList: [
        // { slotName: "approvedType" },
        {
          key: "activityName",
          type: "input",
          labelName: "活动名称:",
          placeholder: "请输入活动名称查询",
          lableWidth: "100px",
        },
        // {
        //   key: "entryTime",
        //   type: "daterange",
        //   labelName: "添加时间:",
        //   placeholder: "请选择添加时间",
        //   valueFormat: "timestamp",
        //   lableWidth: "80px",
        // },
        {
            key: "entryTime",
            type: "pickerOptions",
            labelName: "添加时间",
            lableWidth: "80px",
            placeholder: "请选择添加时间",
            valueFormat: "timestamp",
            clearable:true,
        },
      ],
    };
  },
  created() {
    // this.getadminSelectList();
    console.log(this.initData);
    this.handleConfirm(this.initData);
  },
  watch: {
    "drawerInitData.activityEnd": {
      handler(val) {
        if (val == "00") {
          this.timing = null;
        }
      },
    },
  },
  methods: {
    submitAdd() {
      this.drawerInitData.activityPoster =
        this.posterList[this.isCheckPoster].posterImg;
      this.posterDialogVisible = false;
    },
    // 查看示例图大图
    seeSampleImage(posterImg) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(posterImg);
    },
    automaticClosed() {
      this.createShow = false;
    },
    // 参考海报
    referPic() {
      _api.getPosterList().then((res) => {
        if (res.code == 1) {
          console.log(222, res);
          this.posterList = res.data;
          this.posterDialogVisible = true;
        }
      });
    },
    // 选择海报
    choosePoster(index) {
      this.isCheckPoster = index;
    },
    downPoster(item) {
      const url = item.posterOriginalFile; // 下载文件的url
      const link = document.createElement("a");
      link.href = url;
      link.download = "活动海报.zip"; // 下载文件的名称
      link.click();
    },
    handleUploadDelete() {
      this.drawerInitData.activityPoster = "";
    },
    handleUploadChange(res) {
      this.drawerInitData.activityPoster = res;
    },
    creatSubmit() {
      this.createShow = false;
      this.handleConfirm();
    },
    // 抽屉
    handleClose() {
      this.$refs["drawerForm"].validate((valid) => {
        if (valid) {
          console.log("提交接口", this.drawerInitData);

          const params = {
            activityEnd:
              this.drawerInitData.activityEnd == "01"
                ? this.timing
                  ? moment(this.timing).endOf("day").format("x")
                  : null
                : null,
            activityName: this.drawerInitData.activityName,
            activityPoster: this.drawerInitData.activityPoster,
            activityStart: moment(this.drawerInitData.activityStart)
              .startOf("day")
              .format("x"),
              isOpenGift:this.drawerInitData.isOpenGift,
              subsidyWay:this.drawerInitData.subsidyWay,
            isSave: this.drawerInitData.isSave,
            isTiming: this.drawerInitData.activityEnd == "01" ? true : false,
          };
          console.log("提交接口22", params);

          _api.addActivity(params).then((res) => {
            if (res.code === 1) {
              this.cancelForm();
              this.createShow = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    cancelForm() {
      this.drawerDialog = false;
      this.drawerInitData = {
        isOpenGift:false,
        subsidyWay:"00",
        activityName: "",
        activityPoster: "",
        activityStart: "",
        activityEnd: "00",
        isSave: true,
        isTiming: false,
      };
      this.timing = null;
      this.$refs["drawerForm"].resetFields();
    },
    // end
    //活动名称列表
    // getadminSelectList() {
    //   _api.StaffManageList({ pageNum: 1, pageSize: 99999 }).then((res) => {
    //     this.activitySelectList = res.data.records;
    //   });
    // },
    handleConfirm(data,cd) {
      let startTime = "";
      let endTime = "";
      if (data.entryTime === null) {
      (startTime = ""), (endTime = "");
      } else {
          (startTime = Number(moment(data.entryTime[0]).format("x")) ),
          (endTime = Number(moment(data.entryTime[1]).format("x")));
      }
      let SeachParams = {
        activityName: data && data.activityName ? data.activityName : "",
        startTime: startTime,
        endTime: endTime,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.el_from {
  margin-left: 30px;
  .form_flex_cont {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .drawerWith {
    width: 500px;
  }
  .timeStyle {
    margin-top: 15px;
  }
}
.text-down {
  text-decoration: underline;
  color: #0981ff;
  cursor: pointer;
}
.huanxin {
  padding-left: 20px;
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-radio:nth-of-type(1){
    margin-right: 130px;
  }
}
.wen_text {
  font-size: 12px;
  color: #666666;
  margin-top: -5px;
  line-height: 20px;
}
// /deep/.el-drawer__body{
//   overflow: auto;
// }
</style>
